import styled from 'styled-components';
import SPINNER from '../../../assets/svg/spinner.svg';

interface SpinnerLoaderProps {
  isVisible: boolean;
}

export const SpinnerLoader = ({ isVisible }: SpinnerLoaderProps) => {
  return <Spinner src={SPINNER} isVisible={isVisible} />;
};

const Spinner = styled.img<{ isVisible: boolean }>`
  display: ${(props) => (props.isVisible ? 'block' : 'none')};

  animation: rotation 1s linear infinite;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
